import React from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import instagram from "@static/icons/instagram.svg";
import linkedin from "@static/icons/linkedin.svg";
import twitter from "@static/icons/twitter.svg";

const SocialLinks = () => (
  <Stack direction='row' spacing={2} alignItems='center'>
    <Link href='https://x.com/@Labshare_' target='_blank' underline='none'>
      <Box
        sx={{
          padding: 1,
          background: (theme) => theme.palette.background.paper,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img className='object-contain h-[15px]' src={twitter} alt='Twitter' />
      </Box>
    </Link>
    <Link
      href='https://instagram.com/labshareapp'
      target='_blank'
      underline='none'
    >
      <Box
        sx={{
          padding: 1,
          background: (theme) => theme.palette.background.paper,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img
          className='object-contain h-[15px]'
          src={instagram}
          alt='Instagram'
        />
      </Box>
    </Link>
    <Link
      href='https://www.linkedin.com/company/labshareapp'
      target='_blank'
      underline='none'
    >
      <Box
        sx={{
          padding: 1,
          background: (theme) => theme.palette.background.paper,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img
          className='object-contain h-[15px]'
          src={linkedin}
          alt='LinkedIn'
        />
      </Box>
    </Link>
  </Stack>
);

export default SocialLinks;
